export default __webpack_public_path__ + "static/media/uk.cd2d50bc.png";